import { html } from 'lit';

export const RegistrationInfoScreen = (props: { schoolName: string; klasse: string }) => html`
  <section id="sus-info" class="card scroll-mt-4" aria-labelledby="sus-info-heading">
    <div class="card-body gap-5 p-4 sm:p-6">
      <h2 id="sus-info-heading" class="font-semibold md:text-lg">Informationen zur Bewerbung</h2>
      <p class="max-w-prose leading-relaxed">
        Dies ist das Formular für die Bewerbung Ihres Kindes an der Schule: ${props.schoolName} für die Klassenstufe
        ${props.klasse}.<br />
        Bitte lesen Sie sich die nachfolgenden Hinweise gut durch und füllen Sie alle notwendigen Formularfelder aus.
      </p>
      <ol class="list">
        <li class="list-row items-start">
          <span class="text-2xl font-semibold tabular-nums text-primary" aria-hidden="true">1</span>
          <p class="max-w-prose leading-relaxed">
            Der Link zu diesem Formular ist 21 Tage gültig. Danach müssen Sie die Bewerbung erneut starten.
          </p>
        </li>
        <li class="list-row items-start">
          <span class="text-2xl font-semibold tabular-nums text-primary" aria-hidden="true">2</span>
          <p class="max-w-prose leading-relaxed">
            Alle Daten, die Sie hier eintragen, werden im Hintergrund auf Ihrem eigenen Gerät gespeichert. Sie können
            die Seite also jederzeit verlassen und die Bewerbung später fortsetzen.
          </p>
        </li>
        <li class="list-row items-start">
          <span class="text-2xl font-semibold tabular-nums text-primary" aria-hidden="true">3</span>
          <p class="max-w-prose leading-relaxed">Die Felder mit "*" sind Pflichtfelder und müssen ausgefüllt werden.</p>
        </li>
      </ol>
    </div>
  </section>
`;
